export default __webpack_public_path__ + "static/First-Aid-Case-Travel-Bag-a892f3e645dd9c35c7733614bd52df9b.jpg";